var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"swiper-container1"},[_c('el-carousel',{attrs:{"type":"card","height":"500px"}},_vm._l((_vm.listData1),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"carousel-image",attrs:{"src":item.thumbnail_url,"alt":""}})])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38598018","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiperCover.vue
// module id = null
// module chunks = 